// scoopOS
require('../../vendor/rmts/scoop-os/resources/js/scoop-os-vue');

// If your forms has so called "interactive inputs" (See InteractiveInput.vue), this object handles the needed
// event sharing between those element-components and the view
require('./form-element-relations');

Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
});

import flatPickr from 'vue-flatpickr-component';

Vue.component('flat-pickr', flatPickr);

// LoberonPIM
Vue.component('ProductFilter', require('../js/components/ProductFilter').default);
Vue.component('ProductPager', require('../js/components/ProductPager').default);
Vue.component('ProductStatus', require('../js/components/ProductStatus').default);
Vue.component('ProductTextEditorUsers', require('../js/components/ProductTextEditorUsers').default);
Vue.component('translate-attribute-value', require('../js/components/TranslateAttributeValue').default);
Vue.component('AutosaveTextField', require('../js/components/AutosaveTextField').default);
Vue.component('ImageAssignmentDropArea', require('../js/components/ImageAssignmentDropArea').default);
Vue.component('FilterTranslationProducts', require('./components/FilterTranslationProducts').default);
Vue.component('MediaFilterProductNumber', require('./components/mediaFilter/ProductNumber').default);
Vue.component('MediaFilterPressImages', require('./components/mediaFilter/PressImages').default);
Vue.component('MediaFilterProductCategories', require('./components/mediaFilter/ProductCategories').default);
Vue.component('ProductMassupdate', require('./components/ProductMassupdate').default);
Vue.component('ProductTextExport', require('./components/ProductTextExport').default);
Vue.component('InventoryFilter', require('../../app/SampleManagement/resources/js/components/InventoryFilter').default);
Vue.component('ProductIndex', require('./components/Product/ProductIndex').default);
Vue.component('AxAttributesBase', require('./components/Product/AxAttributesBase').default);
Vue.component('AxAttributesProduct', require('./components/Product/AxAttributesProduct').default);
Vue.component('AxAttributesVariants', require('./components/Product/AxAttributesVariants').default);
Vue.component('AxAttributesVariantColor', require('./components/Product/AxAttributesVariantColor').default);
Vue.component('AxAttributesVariantSize', require('./components/Product/AxAttributesVariantSize').default);
Vue.component('TextAttributeLobMaterials', require('./components/textAttributes/Materials').default);
Vue.component('ColoriconImageAssignmentDropArea', require('../js/components/ColoriconImageAssignmentDropArea').default);
Vue.component('ProductVariantFilter', require('../js/components/ProductVariantFilter').default);
Vue.component('ProductVariantMassupdate', require('./components/ProductVariantMassupdate').default);
Vue.component('ProductCurrentlyNewInClients', require('./components/ProductCurrentlyNewInClients.vue').default);
Vue.component('ProductTexts', require('../js/components/Product/Texts/ProductTexts').default);
Vue.component('TranslationTextareaOriginal', require('../js/components/Product/Texts/TranslationTextareaOriginal').default);
Vue.component('TranslationTextareaTarget', require('../js/components/Product/Texts/TranslationTextareaTarget').default);
